import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route protection component that restricts access to admin and manager users only.
 * Redirects unauthorized users to the home page.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authorized
 * @returns {React.ReactElement} The protected route or redirect
 */
const AdminOrManagerRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Check if user is authenticated and has admin or manager role
  const hasRequiredPermissions = () => {
    if (!user || !user.groups) return false;
    const userGroups = user.groups.map(g => g.toLowerCase());
    return userGroups.includes('admin') || userGroups.includes('manager');
  };

  if (!isAuthenticated || !hasRequiredPermissions()) {
    // Redirect to home if not admin or manager
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminOrManagerRoute;

